import { createAction, handleActions } from 'redux-actions';

// 타입 정의
export const SET_WALLET = 'SET_WALLET';
export const SET_WALLET_INIT = 'SET_WALLET_INIT';
export const SET_MY_ASSET = 'SET_MY_ASSET';

// 액션 내보내기
export const setMyAssets = createAction(SET_MY_ASSET, assets => assets);
export const setWallet = createAction(SET_WALLET, wallet => wallet);
export const setWalletInit = createAction(SET_WALLET_INIT);

// 초기 상태값
const initialState = {
  wallet: [],
  myAssets: {},
  myValuation: {
    buying: '0',
    nowBalance: '0',
    profitAmount: '0',
    profitRate: '0'
  }
};

// 리듀서 내보내기
export default handleActions(
  {
    [SET_WALLET]: (state, { payload }) => {
      if (typeof payload !== 'undefined') {
        return {
          ...state,
          wallet: Object.assign(
            {},
            ...payload.map(n => ({
              [n.symbol]: {
                ...n
              }
            }))
          )
        };
      } else {
        return state;
      }
    },
    [SET_MY_ASSET]: (state, { payload }) => {
      if (payload && typeof payload !== 'undefined') {
        return {
          ...state,
          myAssets: Object.assign(
            {},
            ...payload.map(n => ({
              [n.po_type]: {
                ...n
              }
            }))
          )
        };
      } else {
        return state;
      }
    },
    [SET_WALLET_INIT]: () => {
      return initialState;
    }
  },
  initialState
);
